import { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { clearTokenFromUrl, finalizeSession, getTokenFromUrl, hasExistingSession, logout } from "../utils/sessionInit";

// Gates app render on the `?token=` handoff flow: if a session already
// exists on this device, ask before logging it out, instead of silently
// clobbering it.
function getInitialPhase() {
  console.log(" getTokenFromUrl")
  const token = getTokenFromUrl();
  console.log(token);
  if (!token) return "ready";
  if (hasExistingSession()) return "confirm";

  finalizeSession(token);
  return "ready";
}

export default function SessionGate({ children }) {
  const [phase, setPhase] = useState(getInitialPhase);

  const handleCancel = () => {
    clearTokenFromUrl();
    setPhase("ready");
  };

  return (
    <>
      <Dialog open={phase === "confirm"} disableEscapeKeyDown>
        <DialogTitle>Session already exists</DialogTitle>
        <DialogContent>
          <DialogContentText>
            A session already exists. Please logout to continue.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel}>Cancel</Button>
          <Button onClick={logout} variant="contained" autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
      {phase === "ready" && children}
    </>
  );
}
